import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import * as rootStore from 'stores/root_store';
import arm from '../../../../assets/robotArm.png';
import electro from '../../../../assets/electronics-top-icon.png';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import AllInboxSharpIcon from '@mui/icons-material/AllInboxSharp';
import { Link, useSearchParams } from 'react-router-dom';
import { StatusColor } from '../machineStatus';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import { ROUTES } from 'base/routes/routes';

export function createDiagramMachine() {
  return observer(() => {
    const [wSId] = useSearchParams();

    const [autoRun, setAutoRun] = useState(true);
    const [an, setAn] = useState(false);
    //loading page when reload
    const [isLoading, setIsLoading] = useState(true);
    const diagramRows = rootStore.reportStore.WorkShopEquipmentsStatus.data;
    useEffect(() => {
      setInterval(() => {
        const getWSE = async () => {
          await rootStore.reportPresenter.WorkShopEquipments(rootStore.reportStore, null, null, null, null);
        };

        getWSE();
      }, 60000);
    }, []);

    useEffect(() => {
      setIsLoading(true);
      const getWSE = async () => {
        await rootStore.reportPresenter.WorkShopEquipments(rootStore.reportStore, null, null, null, null);
        setIsLoading(false);
      };

      getWSE();
    }, []);

    // let scrollTimeout: any; // Biến lưu trữ timeout của cuộn
    const [scrollTimeoutID, setScrollTimeoutID] = useState<any>();

    const handleAutoRun = () => {
      // setAutoRun(!autoRun);
      // setAn(true);
      // if (autoRun) pageScroll();
      if (autoRun) {
        function slowScrollToBottom() {
          const windowHeight = window.innerHeight;
          const scrollDuration = 5000; // Thời gian cuộn (ms)
          const scrollStep = (windowHeight / scrollDuration) * 15; // Bước cuộn (px)

          // Hàm đệ quy để cuộn từ từ
          function scrollToBottom(scrollPosition: number) {
            if (scrollPosition < document.documentElement.scrollHeight - windowHeight) {
              window.scrollTo(0, scrollPosition);
              const scrollTimeout = setTimeout(() => {
                scrollToBottom(scrollPosition + scrollStep);
              }, 15); // Thời gian chờ giữa các bước cuộn (ms)
              setScrollTimeoutID(scrollTimeout);
            } else {
              // Khi cuộn đến cuối trang, quay ngược lại đầu trang
              setTimeout(() => {
                scrollToTop(document.documentElement.scrollHeight - windowHeight);
              }, 1000); // Thời gian chờ trước khi quay ngược lại đầu trang (ms)
            }
          }

          // Hàm đệ quy để quay ngược lại đầu trang
          function scrollToTop(scrollPosition: number) {
            if (scrollPosition > 0) {
              window.scrollTo(0, scrollPosition);
              const scrollTimeout = setTimeout(() => {
                scrollToTop(scrollPosition - scrollStep);
              }, 15); // Thời gian chờ giữa các bước cuộn (ms)
              setScrollTimeoutID(scrollTimeout);
            } else {
              // Khi cuộn lên đầu trang, bắt đầu lại quá trình cuộn
              setTimeout(() => {
                scrollToBottom(0);
              }, 1000); // Thời gian chờ trước khi bắt đầu lại cuộn (ms)
            }
          }

          // Bắt đầu cuộn từ đầu trang
          scrollToBottom(0);
          // Trả về hàm để dừng scroll khi cần
        }

        // Gọi hàm để bắt đầu cuộn trang
        slowScrollToBottom();
      } else {
        clearTimeout(scrollTimeoutID);
      }
      setAutoRun(!autoRun);
    };

    return (
      <>
        <div className="flex items-center justify-center flex-col z-50">
          {isLoading && <LoadingScreen />}
          {an === false && (
            <p
              onClick={handleAutoRun}
              className={`fixed text-white rounded-lg z-30 top-2 right-2 align-middle  bg-black bg-opacity-60 p-1 cursor-pointer`}
            >
              <PlayCircleOutlineIcon />
            </p>
          )}
          {diagramRows?.map((item, index) => {
            return (
              <div key={index} className=" w-full mt-5">
                <div className="p-3 border-b-2 border-black text-white bg-[#4682B4] uppercase text-center">
                  <h2 className="text-base font-bold ">{item.workShopName}</h2>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7">
                  {item.workShopEquipments.map((it, id) => {
                    return (
                      <div
                        key={id}
                        className={`
                        ${it.status === StatusColor.HD ? 'bg-green-500' : ''} 
                    ${it.status === StatusColor.CM ? 'bg-[#FEF5AC]' : ''} 
                    ${it.status === StatusColor.VS ? 'bg-[#C1EFFF]' : ''} 
                    ${it.status === StatusColor.NM ? 'bg-[#FFB3B3]' : ''} 
                    ${it.status === StatusColor.ET ? 'bg-white' : ''}
                        col-span-1 p-3 font-semibold rounded-2xl m-2 text-sm shadow-md shadow-gray-800/80`}
                      >
                        <Link className="cursor-pointer" to={ROUTES.REPORTS.REPORT_KHSX.DETAILS_LINK + `/` + it.id}>
                          <div className="text-xs">
                            <div>
                              <h1 className="font-bold text-center min-h-[30px]">{it.equipmentName}</h1>
                            </div>
                            <div className="pb-1 flex items-center gap-3 justify-center border-b border-black border-dashed my-1">
                              <img
                                className=" text-black"
                                width={60}
                                src={it.type?.startsWith('C') ? electro : arm}
                                alt="robotArm"
                              />
                              <span>{it.status}</span>
                            </div>
                            <div>
                              <DescriptionIcon />
                              <span>{it.kssxNumber}</span>
                            </div>
                            <div className="flex">
                              <AllInboxSharpIcon className="mb-2" />
                              <span>{it.productCode}</span>
                            </div>
                            <div>
                              <PersonIcon />
                              <span>{it.numberWorker && it.numberWorker >= 1 ? it.numberWorker + ' người' : ''}</span>
                            </div>
                            <div>
                              <AccessTimeFilledIcon />
                              <span>
                                {it.hourStart} {it.hourEnd !== null ? ' đến ' : ''} {it.hourEnd}
                              </span>
                            </div>
                          </div>

                          <div className="text-xs">
                            <div className="border-b-[3px] border-black  border-dashed my-1"></div>
                            <div>
                              {it.nextWorkOrder &&
                                it.nextWorkOrder.split(',').map((s, index) => (
                                  <div key={index}>
                                    <span>{s}</span>
                                    <br />
                                  </div>
                                ))}
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  });
}
